// eslint-disable-next-line @typescript-eslint/no-var-requires
import * as config from '../config.js';
export const ELMENT_PREFIX = config.elementPrefix;
export const EVENT_PREFIX = config.eventPrefix;
